import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'week'
})



export class WeekPipe implements PipeTransform {
  transform(items:any): Array<any> {
   let datenow=new Date();
  function  getWeekNumber(d: Date): number {
      d = new Date(+d);
      d.setHours(0, 0, 0);
      d.setDate(d.getDate() + 4 - (d.getDay() || 7));
      let yearStart = new Date(d.getFullYear(), 0, 1);
      let weekNo = Math.ceil((((d.valueOf() - yearStart.valueOf()) / 86400000) + 1) / 7);
      return weekNo;
    }
    return items.filter(item => getWeekNumber(datenow) == getWeekNumber(new Date(item.end_date)));
  }
}
